export default __webpack_public_path__ + "94c9cdcb4dfb8180e5f254fe5b40ec33.svg";